import { get, set, merge } from 'lodash';
import moment from 'moment';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER, MEMBER_SEARCH_MODULE } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc ToDoListWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ToDoListWidgetService } from 'services/toDoListWidget';
 *
 * // create service instance and send/cancel request
 * const toDoListWidgetService = new ToDoListWidgetService();
 * const result = await toDoListWidgetService.fetchData( '<user-id>' ); // fetch data
 * toDoListWidgetService.cancel(); // cancel an active request
 */
export class ToDoListWidgetService extends HttpService {

    // fetch call list data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // initiate an outbound call (for member)
    async initiateOutboundCall( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const module = MEMBER_SEARCH_MODULE.DASHBOARD;
        
        // const callerType= getCallerTypeFromName( 'member' );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callType,
                        module,

                        // callerType
                    },
                } ),
            } );

            if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                // set the callStartTime to local UTC time
                set( response, 'body.component.data.state.callStartTime', moment.utc().format() );
                    
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        callData: get( response, 'body.component.data.state', {} )
                    },
                };
            } else {

                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) )
                };
            }

            
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

}
